
import { AssetPreviewTabsController } from './asset-preview-tabs.controller'

function assetPreviewTabs () {
  return {
    restrict: 'E',
    scope: {
      template: '<',
      location: '<',
      contextData: '<',
      previewFlags: '='
    },
    templateUrl: '/core/directives/asset-preview-tabs/asset-preview-tabs.html?$$REVISION$$',
    controller: AssetPreviewTabsController
  }
}
export { assetPreviewTabs }
